import { Progress as AntdProgress } from 'antd'
import styled from '@emotion/styled'

export const Progress = styled(AntdProgress)`
  margin: 0;
  padding: 0;
`
